import React from "react";
import clsx from "clsx";
import styles from "./index.module.scss";

interface IHintChip {
  children: React.ReactNode;
  dotColor?: string;
  className?: string;
}

export const HintChip: React.FC<IHintChip> = ({ children, dotColor, className }) => {
  return (
    <div className={clsx(styles.wrapper, className)}>
      <div className={styles.chip}>
        <span
          className={styles.dot}
          style={dotColor ? { background: dotColor } : undefined}
        />
        {children}
      </div>
    </div>
  );
};
